/**
  ---DO NOT EDIT THIS FILE DIRECTLY---
  This CSS file was concatenated from files listed in the css/ folder as part of a build process
  This is to allow for js import with @import links which will not be followed
**/

/* src/primitives/divider/css/definition/content/divider.css */
@layer divider.definition.content.divider {
  :host {
    display: block;
    margin: var(--divider-margin);
  }
  .divider {
    height: var(--divider-width);
    background: var(--divider-color);
  }
}

/* src/primitives/divider/css/definition/content/text.css */
@layer divider.definition.content.text {
  .divider .text {
    padding: var(--divider-text-padding);
    font-weight: var(--divider-text-font-weight);
    letter-spacing: var(--divider-text-letter-spacing);
    text-transform: var(--divider-text-transform);
    color: var(--divider-text-color);
    white-space: nowrap;
  }
}

/* src/primitives/divider/css/definition/content/icon.css */
@layer divider.definition.content.icon {
  .divider .icon {
    padding: var(--divider-icon-padding);
    font-size: var(--divider-icon-size);
  }
}

/* src/primitives/divider/css/definition/types/horizontal.css */
@layer divider.definition.types.horizontal {
  .divider.horizontal {
    height: auto;
    background: none;
    display: flex;
    align-items: center;
    text-align: center;
  }
  .divider.horizontal .line {
    flex: 1;
    height: var(--divider-width);
    background: var(--divider-color);
  }
}

/* src/primitives/divider/css/definition/variations/spacing.css */
@layer divider.definition.variations.spacing {
  .divider.mini-spacing {
    margin: var(--divider-spacing-mini) 0;
  }
  .divider.tiny-spacing {
    margin: var(--divider-spacing-tiny) 0;
  }
  .divider.small-spacing {
    margin: var(--divider-spacing-small) 0;
  }
  .divider.medium-spacing {
    margin: var(--divider-spacing-medium) 0;
  }
  .divider.large-spacing {
    margin: var(--divider-spacing-large) 0;
  }
  .divider.big-spacing {
    margin: var(--divider-spacing-big) 0;
  }
  .divider.huge-spacing {
    margin: var(--divider-spacing-huge) 0;
  }
  .divider.massive-spacing {
    margin: var(--divider-spacing-massive) 0;
  }
}

/* src/primitives/divider/css/definition/divider-definition.css */

/* src/primitives/divider/css/theme/content/divider-variables.css */
@layer divider.theme.content.divider {
  :host {
    --divider-margin: 1rem 0;
    --divider-width: 1px;
    --divider-color: var(--border-color);
  }
}

/* src/primitives/divider/css/theme/content/text-variables.css */
@layer divider.theme.content.text {
  :host {
    --divider-text-padding: 0 var(--16px);
    --divider-text-font-weight: 700;
    --divider-text-letter-spacing: 0.05em;
    --divider-text-transform: uppercase;
    --divider-text-color: var(--text-color);
  }
}

/* src/primitives/divider/css/theme/content/icon-variables.css */
@layer divider.theme.content.icon {
  :host {
    --divider-icon-padding: 0 1rem;
    --divider-icon-size: 1rem;
  }
}

/* src/primitives/divider/css/theme/types/horizontal-variables.css */
@layer divider.theme.types.horizontal {
  :host {
  }
}

/* src/primitives/divider/css/theme/variations/spacing-variables.css */
@layer divider.theme.variations.spacing {
  :host {
    --divider-spacing-micro: var(--spacing-3xs);
    --divider-spacing-mini: var(--spacing-2xs);
    --divider-spacing-tiny: var(--spacing-xs);
    --divider-spacing-small: var(--spacing-s);
    --divider-spacing-medium: var(--spacing-m);
    --divider-spacing-large: var(--spacing-l);
    --divider-spacing-big: var(--spacing-xl);
    --divider-spacing-huge: var(--spacing-2xl);
    --divider-spacing-massive: var(--spacing-3xl);
  }
}

/* src/primitives/divider/css/theme/divider-theme.css */

/* src/primitives/divider/css/divider.css */
